export default __webpack_public_path__ + "static/media/le_touquet14.c9397d2d.jpg";